<template>
    <div class="meta-nav grid" :class="bemFacet">
        <!-- <pre v-if="container" v-text="container"></pre> -->

        <div class="grid--container meta-nav--container">
            <ul class="u-reset meta-nav--row grid--row">
                <li class="meta-nav--col grid--col" v-for="plugin in plugins">
                    <component :is="plugin.type" :plugin="plugin" :facet="facet"></component>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import bemMixin from 'vue/mixins/bem';
    import cmsPlaceholder from 'vue/mixins/cms/cms-placeholder';


    export default {
        mixins: [
            cmsPlaceholder,
            bemMixin('meta-nav'),
        ],
        props: {
            container: Object,
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?d05cb2b4